import { inject, Injectable, signal } from '@angular/core';
import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class GuestNudgeService {
    private readonly toast = inject(ToastService);

    /** Signal to trigger the choice modal (web signup vs mobile download) */
    readonly showChoiceModal = signal(false);

    /** Signal to trigger conversion modal from anywhere */
    readonly showConversionModal = signal(false);

    /**
     * Show an upgrade nudge toast with a "Sign up free" CTA.
     * Called by the auth interceptor on 403 guest_upgrade_required responses.
     */
    showUpgradeNudge(message?: string): void {
        this.toast.info(message ?? 'Sign up to access this feature.');
    }

    openChoiceModal(): void {
        this.showChoiceModal.set(true);
    }

    closeChoiceModal(): void {
        this.showChoiceModal.set(false);
    }

    /**
     * Open the conversion modal programmatically.
     * Called by CTA buttons, banner clicks, or when message limit reached.
     */
    openConversionModal(): void {
        this.showConversionModal.set(true);
    }

    /**
     * Close the conversion modal.
     */
    closeConversionModal(): void {
        this.showConversionModal.set(false);
    }
}
